<div class="tipo-arquivo-filter">
    <div class="tipo-arquivo-filter-quick">  
        <div class="tipo-arquivo-filter-quick-block tipo-arquivo-filter-quick-block-options-multiselect">
            <!-- Situações -->
            <div class="tipo-arquivo-filter-quick-block-options-multiselect-item">
                <sgt-tipo-arquivo-situacao-multiselect
                    [(situacoes)]="filter.situacoes"
                    (situacoesChange)="onChangeSituacoes()"
                    defaultTitle="Situações"
                    [disabled]="!isFilterInitialized">
                </sgt-tipo-arquivo-situacao-multiselect>
            </div>

            <!-- Referências -->
            <div class="tipo-arquivo-filter-quick-block-options-multiselect-item">
                <sgt-arquivo-referencia-multiselect
                    [(referencias)]="filter.referencias"
                    (referenciasChange)="onChangeReferencias()"
                    defaultTitle="Referências"
                    [disabled]="!isFilterInitialized">
                </sgt-arquivo-referencia-multiselect>
            </div>                
        </div>

        <div class="tipo-arquivo-filter-quick-block tipo-arquivo-filter-quick-block-filter-psq">
            <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
        </div>        

        <div class="tipo-arquivo-filter-quick-block tipo-arquivo-filter-quick-block-options">
            <div class="tipo-arquivo-filter-quick-block-options-btns">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-sync"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
    
                    <!--
                    <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                        (click)="toggleCollapse()" title="Filtro avançado"
                        [disabled]="!isFilterInitialized">
                        <ng-template [ngIf]="isFilterInitialized">
                            <i class="fas fa-filter" aria-hidden="true"></i>
                            <i [class]="collapseIcon" aria-hidden="true"></i>
                        </ng-template>
                        <ng-template [ngIf]="isFilterInitializing">
                            <i class='fas fa-spinner fa-pulse'></i>
                        </ng-template>
                    </button>
                    -->
                </div>  
            </div>
        </div>
    </div>

    
    <div class="tipo-arquivo-filter-collapse" #filterCollapse></div>
</div>

